export default {
  data: () => ({
    error: null
  }),
  methods: {
    setError (error) {
      this.$log.error(error);
      this.error = error.message;

      setTimeout(() => {
        this.error = null;
      }, 6000);
    }
  }
};
